import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { CreateCollegeDialogComponent } from './dialogs/create-college-dialog/create-college/create-college-dialog.component';
import { EditCollegeDialogComponent } from './dialogs/edit-college-dialog/edit-college-dialog.component';
import { DeleteCollegeDialogComponent } from './dialogs/delete-college-dialog/delete-college-dialog.component';
import { CollegeService } from '../../services/college.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { College } from '../../models/college.model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableResponsiveModule } from '../../mat-table-responsive.module';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

export interface CollegeTable {
  name: string;
  emailDomain: string;
  status: string;
}
@Component({
  selector: 'app-colleges',
  standalone: true,
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatTableResponsiveModule,
    CommonModule,
  ],
  templateUrl: './colleges.component.html',
  styleUrl: './colleges.component.scss',
})
export class CollegesComponent implements OnInit {
  loading: boolean = false;
  displayedColumns: string[] = [
    'name',
    'emailDomain',
    'status',
    'campuses',
    'manage',
  ];
  dataSource = new MatTableDataSource<CollegeTable>([]);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private collegeService: CollegeService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.collegeService.getAllColleges().subscribe({
      next: (response) => {
        this.loading = false;
        this.dataSource = new MatTableDataSource(response);
        this.dataSource.paginator = this.paginator;
      },
      error: () => {
        this.loading = false;
        this.snackBar.open(
          'An error occured while retrieving colleges. Please try again.',
          '',
          { duration: 3000 }
        );
      },
    });
  }

  openCreateDialog() {
    const dialogRefCreate = this.dialog.open(CreateCollegeDialogComponent);

    dialogRefCreate.afterClosed().subscribe((result) => {
      if (result) {
        this.snackBar.open(result.message ?? 'An error has occurred.', '', {
          duration: 4000,
        });
      }
    });
  }

  openEditDialog(college: College) {
    this.dialog.open(EditCollegeDialogComponent, {
      height: '45%',
      width: '70%',
      data: { collegeToEdit: college },
    });
  }

  openDeleteDialog(college: any) {
    const dialogRefDelete = this.dialog.open(DeleteCollegeDialogComponent, {
      data: { name: college.name, id: college.id },
    });

    dialogRefDelete.afterClosed().subscribe((result) => {
      if (result) {
        this.snackBar.open(result.message ?? 'An error has occurred.', '', {
          duration: 4000,
        });
      }
    });
  }

  navigateToCampus(collegeId: string) {
    this.router.navigateByUrl(`/campuses/${collegeId}`);
  }
}
